import { render, staticRenderFns } from "./AxHeadingLogo.vue?vue&type=template&id=f7113f56&scoped=true&"
import script from "./AxHeadingLogo.vue?vue&type=script&lang=ts&"
export * from "./AxHeadingLogo.vue?vue&type=script&lang=ts&"
import style0 from "./AxHeadingLogo.vue?vue&type=style&index=0&id=f7113f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7113f56",
  null
  
)

export default component.exports